// "Vis veterinær på faktura" (customer.featureFlags.showVetOnInvoice) — mirror of
// backend/lib/invoice-vet.js for the in-app receipt/invoice print
// (components/dyrejournal/saleReceipt.js). The vet of a line is
// product.saleUser, falling back to sale.user (same as the Selger column).
// System-generated lines can opt out with product.skipVetOnInvoice.
// One vet on every line → one "Veterinær: <name>" line in the header; different
// vets (samlefaktura) → the name under each product line. TICKET-01475.

export const VET_LABEL = 'Veterinær';

export function isVetOnInvoiceEnabled(customer) {
    const flags = (customer && customer.featureFlags) || {};
    return parseInt(flags.showVetOnInvoice, 10) === 1;
}

function positiveId(value) {
    const n = Number(value);
    return Number.isFinite(n) && n > 0 ? n : 0;
}

export function getLineVetId(line, sale) {
    if (line && line.skipVetOnInvoice) {
        return 0;
    }
    return positiveId(line && line.saleUser) || positiveId(sale && sale.user);
}

export function formatVetName(user) {
    if (!user) {
        return '';
    }
    const full = `${(user.firstname || '').trim()} ${(user.lastname || '').trim()}`.trim();
    return full || (user.name || '').trim();
}

/**
 * @param {object} line - product line
 * @param {object} sale - the sale (for the sale.user fallback)
 * @param {function} getEmployee - id → employee object (saleStore.getEmployee)
 */
export function getLineVetName(line, sale, getEmployee) {
    const id = getLineVetId(line, sale);
    if (!id || typeof getEmployee !== 'function') {
        return '';
    }
    return formatVetName(getEmployee(id));
}

/**
 * Returns { header, perLine } — see backend/lib/invoice-vet.js resolveInvoiceVets.
 */
export function resolveInvoiceVets(sale, getEmployee) {
    const lines = (sale && sale.products) || [];
    if (!lines.length) {
        return { header: '', perLine: false };
    }
    const names = lines.map(line => getLineVetName(line, sale, getEmployee));
    const distinct = [...new Set(names)];
    if (distinct.length === 1 && distinct[0]) {
        return { header: distinct[0], perLine: false };
    }
    if (distinct.some(Boolean)) {
        return { header: '', perLine: true };
    }
    return { header: '', perLine: false };
}
